/* ========================================
   SCULPT SOCIETY — THEME JAVASCRIPT
   ======================================== */

(function() {
  'use strict';

  /* --- HEADER SCROLL EFFECT --- */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* --- MOBILE MENU --- */
  const menuToggle = document.querySelector('.site-header__menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuClose = document.querySelector('.mobile-menu__close');
  const menuOverlay = document.querySelector('.mobile-menu__overlay');

  function openMenu() {
    if (mobileMenu) {
      mobileMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeMenu() {
    if (mobileMenu) {
      mobileMenu.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  /* --- PRODUCT IMAGE SLIDER --- */
  const slider = document.getElementById('product-slider');
  if (slider) {
    const slides = slider.querySelectorAll('.main-product__slide');
    const prevBtn = document.getElementById('slider-prev');
    const nextBtn = document.getElementById('slider-next');
    const currentSpan = document.getElementById('slide-current');
    const thumbnails = document.querySelectorAll('.main-product__thumbnail');
    let currentIndex = 0;
    const totalSlides = slides.length;

    function showSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      slides.forEach(function(s) { s.classList.remove('active'); });
      slides[index].classList.add('active');
      thumbnails.forEach(function(t) { t.classList.remove('active'); });
      if (thumbnails[index]) thumbnails[index].classList.add('active');
      currentIndex = index;
      if (currentSpan) currentSpan.textContent = index + 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { showSlide(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { showSlide(currentIndex + 1); });

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        showSlide(parseInt(this.getAttribute('data-index')));
      });
    });

    // Touch swipe for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    slider.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    slider.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      if (touchStartX - touchEndX > 50) showSlide(currentIndex + 1);
      if (touchEndX - touchStartX > 50) showSlide(currentIndex - 1);
    }, { passive: true });
  }

  /* --- ACCORDIONS --- */
  document.querySelectorAll('.accordion__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const accordion = this.closest('.accordion');
      const content = this.nextElementSibling;
      const isOpen = this.getAttribute('aria-expanded') === 'true';

      // For size page accordions, close siblings
      if (accordion && accordion.classList.contains('accordion--size')) {
        const parent = accordion.parentElement;
        if (parent) {
          parent.querySelectorAll('.accordion--size').forEach(function(sib) {
            sib.classList.remove('active');
            var sibTrigger = sib.querySelector('.accordion__trigger');
            var sibContent = sib.querySelector('.accordion__content');
            if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
            if (sibContent) {
              sibContent.classList.remove('open');
              sibContent.style.display = 'none';
            }
          });
        }
      }

      if (isOpen) {
        this.setAttribute('aria-expanded', 'false');
        if (content) {
          content.classList.remove('open');
          content.style.display = 'none';
        }
        if (accordion) accordion.classList.remove('active');
      } else {
        this.setAttribute('aria-expanded', 'true');
        if (content) {
          content.classList.add('open');
          content.style.display = 'block';
        }
        if (accordion) accordion.classList.add('active');
      }
    });
  });

  /* --- QUANTITY SELECTOR --- */
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus = document.getElementById('qty-plus');
  const qtyInput = document.getElementById('qty-input');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  /* --- COLOR SWATCH SELECTION --- */
  document.querySelectorAll('.main-product__color-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      document.querySelectorAll('.main-product__color-swatch').forEach(function(s) { s.classList.remove('active'); });
      this.classList.add('active');
      var colorName = this.getAttribute('data-color');
      var label = document.getElementById('selected-color');
      if (label) label.textContent = colorName;
      updateVariant();
    });
  });

  /* --- SIZE BUTTON SELECTION --- */
  document.querySelectorAll('.main-product__size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.main-product__size-btn').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      var sizeName = this.getAttribute('data-size');
      var label = document.getElementById('selected-size');
      if (label) label.textContent = sizeName;
      updateVariant();
    });
  });

  /* --- VARIANT SELECTION --- */
  function updateVariant() {
    var productJson = document.getElementById('product-json');
    if (!productJson) return;

    try {
      var product = JSON.parse(productJson.textContent);
      var selectedColor = '';
      var selectedSize = '';

      var colorEl = document.querySelector('.main-product__color-swatch.active');
      if (colorEl) selectedColor = colorEl.getAttribute('data-color');

      var sizeEl = document.querySelector('.main-product__size-btn.active');
      if (sizeEl) selectedSize = sizeEl.getAttribute('data-size');

      var variantSelect = document.getElementById('product-variant-select');
      if (!variantSelect || !product.variants) return;

      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var title = variant.title || '';
        var match = true;

        if (selectedColor && title.indexOf(selectedColor) === -1) match = false;
        if (selectedSize && title.indexOf(selectedSize) === -1) match = false;

        if (match) {
          variantSelect.value = variant.id;

          // Update price display
          var priceEl = document.querySelector('.main-product__price');
          var addToCartBtn = document.getElementById('add-to-cart');
          if (priceEl && variant.price) {
            var price = (variant.price / 100).toFixed(2);
            priceEl.textContent = '$' + price;
            if (addToCartBtn) {
              addToCartBtn.textContent = 'ADD TO CART — $' + price;
            }
          }
          break;
        }
      }
    } catch(e) {
      // Silent fail
    }
  }

  /* --- CART DRAWER --- */
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartToggle = document.querySelector('.site-header__cart-btn');
  var cartClose = document.querySelector('.cart-drawer__close');
  var cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
      fetchCart();
    }
  }
  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) cartToggle.addEventListener('click', function(e) { e.preventDefault(); openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function() {});
  }

  function updateCartCount(count) {
    var countEls = document.querySelectorAll('.site-header__cart-count');
    countEls.forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartDrawer(cart) {
    var itemsContainer = document.querySelector('.cart-drawer__items');
    var subtotalEl = document.querySelector('.cart-drawer__total-price');
    if (!itemsContainer) return;

    if (cart.items.length === 0) {
      itemsContainer.innerHTML = '<p style="text-align:center;color:#888;padding:40px 0;">Your cart is empty</p>';
    } else {
      var html = '';
      cart.items.forEach(function(item) {
        var price = (item.price / 100).toFixed(2);
        var linePrice = (item.line_price / 100).toFixed(2);
        var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
        html += '<div class="cart-drawer__item" style="display:flex;gap:16px;padding:16px 0;border-bottom:1px solid #eee;">';
        html += '<img src="' + imgSrc + '" alt="' + item.title + '" style="width:70px;height:70px;object-fit:cover;border-radius:8px;">';
        html += '<div style="flex:1;"><div style="font-weight:600;font-size:14px;">' + item.product_title + '</div>';
        html += '<div style="font-size:12px;color:#888;">' + item.variant_title + '</div>';
        html += '<div style="font-size:14px;font-weight:600;margin-top:4px;">$' + linePrice + '</div>';
        html += '<div style="display:flex;align-items:center;gap:8px;margin-top:8px;">';
        html += '<button onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity - 1) + ')" style="width:28px;height:28px;border:1px solid #ddd;border-radius:4px;background:#fff;cursor:pointer;">-</button>';
        html += '<span style="font-size:14px;">' + item.quantity + '</span>';
        html += '<button onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity + 1) + ')" style="width:28px;height:28px;border:1px solid #ddd;border-radius:4px;background:#fff;cursor:pointer;">+</button>';
        html += '</div></div></div>';
      });
      itemsContainer.innerHTML = html;
    }

    if (subtotalEl) {
      subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
    }
  }

  // Global function for cart item updates
  window.updateCartItem = function(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
    })
    .catch(function() {});
  };

  /* --- AJAX ADD TO CART --- */
  var addToCartForm = document.querySelector('.main-product form[action*="/cart/add"]') || document.querySelector('.main-product form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(this);
      var data = {};
      formData.forEach(function(value, key) { data[key] = value; });

      var btn = document.getElementById('add-to-cart');
      if (btn) {
        var originalText = btn.textContent;
        btn.textContent = 'ADDING...';
        btn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(data.id), quantity: parseInt(data.quantity) || 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        if (btn) {
          btn.textContent = 'ADDED!';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        }
        openCart();
      })
      .catch(function() {
        if (btn) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      });
    });
  }

  /* --- HORIZONTAL SCROLL DRAG --- */
  document.querySelectorAll('.transformations__carousel, .tiktok-section__carousel, .reviews-section__carousel, .product-transformations__carousel, .product-reviews__photo-strip').forEach(function(carousel) {
    var isDown = false;
    var startX;
    var scrollLeft;

    carousel.addEventListener('mousedown', function(e) {
      isDown = true;
      carousel.style.cursor = 'grabbing';
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });
    carousel.addEventListener('mouseleave', function() {
      isDown = false;
      carousel.style.cursor = 'grab';
    });
    carousel.addEventListener('mouseup', function() {
      isDown = false;
      carousel.style.cursor = 'grab';
    });
    carousel.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - carousel.offsetLeft;
      var walk = (x - startX) * 2;
      carousel.scrollLeft = scrollLeft - walk;
    });

    carousel.style.cursor = 'grab';
  });

  /* --- INITIAL CART COUNT --- */
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { updateCartCount(cart.item_count); })
    .catch(function() {});

  /* --- POPUP/MODAL (email capture) --- */
  var popupShown = sessionStorage.getItem('sculpt_popup_shown');
  if (!popupShown) {
    setTimeout(function() {
      var popup = document.getElementById('email-popup');
      if (popup) {
        popup.style.display = 'flex';
        sessionStorage.setItem('sculpt_popup_shown', 'true');
      }
    }, 5000);
  }

  var popupClose = document.getElementById('popup-close');
  if (popupClose) {
    popupClose.addEventListener('click', function() {
      var popup = document.getElementById('email-popup');
      if (popup) popup.style.display = 'none';
    });
  }

})();
